import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Area {
    /**
    * 获取省
    */
    export var area = (): Promise<any> => {
        return Get(`/msls/AreaApi/GetProvince`, {});
    };
    /**
    * 获取市
    */
    export var city = (provincecode): Promise<any> => {
        return Get(`/msls/AreaApi/GetCity/${provincecode}`, {});
    };
    /**
    * 获取区
    */
    export var county = (citycode): Promise<any> => {
        return Get(`/msls/AreaApi/GetCounty/${citycode}`, {});
    };
    export var areaNew = (obj): Promise<any> => {
        return Get(`/api/Zone?${qs.stringify(obj)}`, {});
    };

    export var getAllArea = (obj): Promise<any> => {
        return Get(`/csp/Area/getAllArea?${qs.stringify(obj)}`, {});
    };
}
